import $ from 'jquery';
import 'webpack-jquery-ui/tooltip';
import './hidden-flag-uk-leaflet.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'theme/moydom/less/template.less';

import 'ui/header';
import MainHeader from 'ui/header/main';
import HeaderNavigation from 'ui/header/pageHeaderNavigation';
import 'ui/footer';
import ImageZoom from 'ui/image/image-zoom.js';

// import elevator from 'ui/toTop.js';
import CookieMessage from 'ui/cookie-message/controller';
import PhoneConform from 'modules/main/phone-confirm';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import '../subscribe/share-app';


$(() => {
    new MainHeader().init();

    new HeaderNavigation().init();

    // Модалка регистрации/авторизации
    $('body').on('click', '.js-needAuth', () => {
        authModal.show();
    });

    const { activeCity } = window.BaseApp.initData;
    if (activeCity == null) {
        $('#selectCityModal').modal('show');
        $('#selectCityModal').on('hidden.bs.modal', (e) => {
            const url = $(e.target).find('.active').attr('href');
            $.ajax({ method: 'GET', data: { XSDID: yii.getCsrfParam() }, url });
        });
    }

    if (window.BaseApp.initData.showCookieMessage) {
        new CookieMessage().init();
    }

    // вывод модального окна для скачивания приложения
    const flagModalApp = JSON.parse(localStorage.getItem('flag_showModalMobileApp'));
    if (flagModalApp == null){
        let modalDownloadApp = document.getElementById("modalDownloadApp");

        if (modalDownloadApp){
            $('#modalDownloadApp').modal('show');
            $('#modalDownloadApp').on('hidden.bs.modal', (e) => {
                localStorage.setItem('flag_showModalMobileApp', JSON.stringify({ flag: true }));
            });
        }
    }

    new PhoneConform().init();

    ImageZoom.init();
});
